import { NgModule } from '@angular/core';
import { DialogsModule } from '../core/dialogs/dialogs.module';

// Routes are provided in main.ts (provideRouter with view transitions).
@NgModule({
  declarations: [],
  imports: [DialogsModule],
})
export class PagesModule {}
